@if (headline()) {
  <div class="basis-full flex flex-row items-center mb-3 rounded-t-md">
    <div class="grow text-[1.125rem] font-medium flex items-center">
      {{headline()}}
    </div>
    <nx-default-button
      [style]="'dark'"
      [tooltip]="'Zeiteintrag hinzufügen'"
      [icon]="'icon-plus'"
      (click)="createTimeEntry()">
    </nx-default-button>
  </div>
}

@if (categorySums().length === 0) {
  <div 
    class="text-base border border-dashed rounded-md min-h-[74px] flex flex-col items-center justify-center transition-colors text-gray-400 border-gray-300">
    <span class="font-normal text-base">{{emptyMessage()}}</span>
  </div>
}

@if (categorySums().length > 0) {
  <div class="mt-2">
    <!-- Horizontaler Balken mit Zeitverteilung -->
    <div class="flex h-2 w-full overflow-hidden">
      @for (categoryPercentage of categoryPercentages(); track categoryPercentage.categoryId; let isFirst = $first; let isLast = $last) {
        <div 
          [style.width.%]="categoryPercentage.percentage"
          [style.background-color]="categoryPercentage.categoryColor"
          [class.rounded-l]="isFirst"
          [class.rounded-r]="isLast"
          [title]="categoryPercentage.categoryName + ': ' + categoryPercentage.percentage.toFixed(1) + '%'">
        </div>
      }
    </div>

    <!-- Labels für Verteilungsbalken -->
    <div class="flex items-center justify-between mt-1 text-base">
      <span class="text-gray-500">0 Std</span>
      <span class="text-gray-900 font-medium">Gesamt: {{formatDurationToStd(totalDuration())}}</span>
    </div>

    <!-- Kategorien als Accordions -->
    <div class="mt-3 flex flex-col gap-1">
      @for (categorySum of categorySums(); track categorySum.category.id) {
        <app-timeEntry-category-accordion
          [categorySum]="categorySum"
          [ownerId]="ownerId()!"
          [ownerType]="ownerType()!"
          [totalDuration]="totalDuration()">
        </app-timeEntry-category-accordion>
      }
    </div>
  </div>
}
